import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef } from '@app/core/services/dialog-ref';
import { DIALOG_DATA } from '@app/core/services/dialog-token';

export interface ConfirmationDialogModel {
  title?: string;
  message?: string;
  footer?: string;
  allowCancel?: boolean;
  cancelText?: string;
  confirmText?: string;
  severity?: 'default' | 'danger';
}

@Component({
  selector: 'if-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ConfirmationDialogComponent {
  protected readonly data = inject<ConfirmationDialogModel>(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
